import { render, staticRenderFns } from "./Occupations.vue?vue&type=template&id=bff8f7ea"
import script from "./Occupations.vue?vue&type=script&lang=js"
export * from "./Occupations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bff8f7ea')) {
      api.createRecord('bff8f7ea', component.options)
    } else {
      api.reload('bff8f7ea', component.options)
    }
    module.hot.accept("./Occupations.vue?vue&type=template&id=bff8f7ea", function () {
      api.rerender('bff8f7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/occupation/Occupations.vue"
export default component.exports